import * as ko from 'knockout';
import { place_address } from 'entitiesE';
import { place_contact } from 'entitiesE';
import entityBase from 'entityBase';

export class place extends entityBase {
    name    : KnockoutObservable<string>;
    place_id: KnockoutObservable<string>;
    place_address: KnockoutObservableArray<place_address>;
    place_contact: KnockoutObservableArray<place_contact>;

    constructor(item: any){
        super();
        this.name     = ko.observable(item.name).extend({ maxLength: 128 });
        this.place_id = ko.observable(item.place_id).extend({ maxLength: 32 });
        this.place_address = ko.observableArray();
        this.place_contact = ko.observableArray();
        if(item.place_address) {
            this.place_address = <KnockoutObservableArray<place_address>>this.loadRelation(item, place_address, "place_address", "array");
        }
        if(item.place_contact) {
            this.place_contact = <KnockoutObservableArray<place_contact>>this.loadRelation(item, place_contact, "place_contact", "array");
        }
    }
}


